module.exports = __webpack_public_path__ + "media/help.b5d00b84.mp3";